var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.058,
    height: 17.058,
    viewBox: "0 0 17.058 17.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23005",
    "data-name": "Group 23005",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23006",
    "data-name": "Group 23006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.366,
    cy: 6.366,
    r: 6.366,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.366,
    cy: 6.366,
    r: 7.116,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    x2: 2.994,
    y2: 2.994,
    transform: "translate(11.503 11.503)",
    fill: "none",
    stroke: "#000c1f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.e14576bc7b24fddbd3cd16faa26c7cd4.svg";
export { ForwardRef as ReactComponent };